import {ABACPolicyEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ABACPolicyAction} from "./ABACPolicyActionMenu";
import {useABACPolicyMutation} from "../../../hooks/useABACPolicyMutation";

export type UseABACPolicyActionProps = {}

export type UseABACPolicyActionResult = {
  onABACPolicyActionClick: (abacPolicy: ABACPolicyEntity, action: ABACPolicyAction) => void;
}

export const useABACPolicyAction = (props: UseABACPolicyActionProps = {}): UseABACPolicyActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteABACPolicy,
  } = useABACPolicyMutation()

  const _onABACPolicyActionClick = useCallback((abacPolicy: ABACPolicyEntity, action: ABACPolicyAction) => {
    if (action === "EDIT") {
      navigate(`/abac-policies/form`, {state: {id: abacPolicy.id}})
    } else if (action === "DELETE") {
      deleteABACPolicy(abacPolicy.id, undefined)
    }
  }, [navigate, deleteABACPolicy])

  return {
    onABACPolicyActionClick: _onABACPolicyActionClick
  }
}
